/*********************************************************************************
 * Copyright (C) 2025 VECROS Technologies Pvt. Ltd.
 * <legal@vecros.com>
 * This file is part of VECROS CLOUD SOFTWARE SERVICES maintained and developed by VECROS TECHNOLOGIES PRIVATE LIMITED.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 **********************************************************************************/

import React, {useEffect, useRef} from 'react';
import { Box, InputAdornment, TextField } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { useTheme } from '@mui/styles';


const SearchBarContainer = ({searchQuery, setSearchQuery, onSearch }) => {
    const theme = useTheme();
    const isRendered = useRef(true)
    const handleChange = (e) => {
        setSearchQuery(e.target.value);
    };

    useEffect(() => {
        if(isRendered.current){
            isRendered.current = false
            return
        }
        const timer = setTimeout(() => {
            onSearch(searchQuery)
        }, 800)
        return () => clearTimeout(timer)
    // onSearch is recreated by the parent each render; listing it would reset the
    // debounce timer continuously and the search would never fire.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchQuery])

    return (
        <Box >
            <TextField
                variant="outlined"
                placeholder="Search..."
                value={searchQuery}
                onChange={handleChange}
                InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                    <SearchIcon sx={{
                        fontSize: '18px'
                    }} />
                    </InputAdornment>
                ),
                sx: {
                    backgroundColor: 'transparent',
                    borderColor: theme.palette.border.color,
                    borderRadius: 3,
                    "& input::placeholder": {
                    fontSize: "12px", 
                    },
                    '& .MuiOutlinedInput-input': {
                        padding: '10px 14px',
                        borderColor: theme.palette.border.color,
                        paddingLeft: '0px',  
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.border.color,  
                        borderWidth: "1px",  
                    },
                }
                }}
                sx={{
                    // padding: '6px 8px',
                    boxSizing: 'border-box',
                    width: '300px'
                }}
            />
        </Box>

    )
};


export default SearchBarContainer;
